<template>
<v-card class='ma-0' >
  <a name="top" id="top" ></a>
  <v-toolbar flat >

    <!-- <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-chip color='primary' small label dark v-on="on" >LA</v-chip>
      </template>
      <span>Limited Availability - This functionality may change in the future</span>
    </v-tooltip> -->
    <v-progress-circular v-if='response.loading' width='2' color='amber' indeterminate ></v-progress-circular>
    <v-icon v-else >send</v-icon>
    <v-toolbar-title class='hidden-xs-only'>
      Messages
    </v-toolbar-title>
    <span v-if='totalResults' class='ml-2 pt-1 hidden-xs-only' >
      Showing {{messages.length}} of {{totalResults}} messages
    </span>
    <v-spacer></v-spacer>
    <v-text-field
      label='search'
      hint='press enter to search'
      @keypress.enter = 'dosearch'
      @click:append = 'dosearch'
      @click:clear = 'dosearch(10)'
      clearable
      v-model='search'
      append-icon='search' >
    </v-text-field>
    <v-switch v-model='failed' class='pl-3 ml-3 mr-3 mt-3' style='flex:none' label='Only failed'></v-switch>
    <v-divider vertical ></v-divider>
    <v-btn small icon @click='fetch'  ><v-icon>replay</v-icon></v-btn>
  </v-toolbar>
  <v-progress-linear v-if='response.loading' class='ma-0' height='2' indeterminate ></v-progress-linear>
  <v-divider></v-divider>
  <v-tabs
    background-color='gray lighten-4'
    v-model='activeTab' >
    <v-tab >{{ $t('tabs.inbox') }}</v-tab>
    <v-tab v-if='$store.getters.isAdmin' >{{ $t('tabs.communicationtemplates') }}</v-tab>
    <v-tabs-items v-model='activeTab' >
      <v-divider></v-divider>
      <v-tab-item >
        <inbox :messages='messages' @selected='setSelected' ></inbox>

        <v-layout justify-center >
          <v-pagination circle
            v-model="page" :length="numPages"
            :total-visible='pagesVisible'
            @input='$vuetify.goTo("#top")'
            class='my-2 mr-4' >
          </v-pagination>
        </v-layout>
        <v-footer v-if='numPages > 1' class="text-xs-center">
          <v-icon class='ml-2 mr-2' small >info</v-icon>
          <small>Notification data is only available for more recent notifications</small>
          <v-spacer></v-spacer>
          <v-progress-circular v-if='response.loading' width='2' color='amber' indeterminate ></v-progress-circular>
        </v-footer>
        <v-list-tile v-if='!response.loading && messages.length === 0' >
          <v-list-tile-content >
            No messages found
          </v-list-tile-content>
        </v-list-tile>
      </v-tab-item>
      <v-tab-item >
        <v-window v-model="templatePage" vertical touchless >
          <v-window-item >
            <!-- :context='templateContext' -->
            <communication-template-list
              @selected='setSelectedCommunicationTemplate'
              @new='setSelectedCommunicationTemplate(null)'
              :title='$t("comms.title")' >
            </communication-template-list>
          </v-window-item>
          <v-window-item >
            <communication-template-form
              v-model='selectedTemplate'
              @close='templatePage=0'
              context-type='Appointment' >
            </communication-template-form>
          </v-window-item>
        </v-window>
      </v-tab-item>
    </v-tabs-items>
    <v-spacer/>
    <!-- <v-btn small outline class="mt-2" @click="showCompose=true" >Compose</v-btn> -->
    <v-dialog v-model="showCompose" width="600" >
      <v-card>
        <v-card-title class='py-0 overline grey lighten-4' >
          Compose message
          <v-spacer/>
          <v-btn @click="showCompose=false" small icon ><v-icon small >close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <compose />
      </v-card>
    </v-dialog>
  </v-tabs>

  <v-navigation-drawer persistent right fixed hide-overlay
    v-model='showDetail' width="400"
    style='z-index:11;' >
    <v-system-bar status dark class='visible-ios-only main' >
    </v-system-bar>
    <v-toolbar flat dark dense >
      <v-spacer></v-spacer>
      <v-btn @click='selected=null;showDetail=false' icon ><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <communication-card v-if='selected' :id='selected.id' :initial-data='selected' :fetch='true' >
    </communication-card>
  </v-navigation-drawer>

</v-card>
</template>
<script>
import CommunicationCard from './CommunicationCard'
import Compose from './Compose.vue'
import Inbox from './Inbox'
import CommunicationTemplateForm from '@/components/forms/CommunicationTemplateForm'
import CommunicationTemplateList from '@/components/lists/CommunicationTemplateList'

export default {
  name: 'CommunicationsPage',
  components: {CommunicationCard, Inbox, CommunicationTemplateForm, CommunicationTemplateList, Compose},
  data () {
    return {
      reqId: 'get-messages',
      activeTab: 0,
      templatePage: 0,
      selectedTemplate: null,
      selectedTemplateSlug: null,
      search: null,
      showDetail: false,
      failed: false,
      page: 1,
      pagesVisible: 7,
      showCompose: 0,
      selected: null
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    mainClasses () {
      if (this.selected) {
        return ['xs12', 'sm7', 'lg8', 'pr-0']
      }
      return ['xs-12']
    },
    response () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    totalResults () {
      return this.getObjectPath(this.response, 'result.data.count', 0)
    },
    numPages () {
      if (this.totalResults === 0) { return 0 }
      return Math.ceil(parseInt(this.totalResults) / this.messages.length)
    },
    messages () {
      let messages = this.getObjectPath(this.response, 'result.data.results', [])
      if (messages && messages.length > 0) {
        // this.$store.commit('addManyCommunications', messages)
      }
      return messages
    }
  },
  watch: {
    failed () {
      this.page = 1
      this.fetch()
    },
    page () {
      this.fetch()
    }
  },
  methods: {
    dosearch (wait = 0) {
      this.page = 1
      window.setTimeout(this.fetch, wait)
    },
    setSelected (message) {
      this.selected = message
      this.showDetail = true
    },
    setSelectedCommunicationTemplate (template) {
      if (template) {
        this.selectedTemplate = template
        this.selectedTemplateSlug = template.slug
      } else {
        this.selectedTemplate = null
        this.selectedTemplateSlug = null
      }
      this.templatePage = 1
    },
    fetch () {
      let params = {
        page: this.page
      }
      if (this.failed) {
        params['status'] = 'failed'
      }
      if (this.search && this.search.length > 0) {
        params['search'] = this.search
      }
      this.$communicationguru
          .resource('communication')
          .id(this.reqId)
          .list(params)
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          inbox: 'Inbox',
          communicationtemplates: 'Templates'
        },
        comms: {
          title: 'Message templates'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?5aca89d9